import useEventListener from "@use-it/event-listener";
import { useCallback, useState } from "react";
import { ScreenSize } from "types";
import { debounce } from "lodash";
import { MOBILE_WIDTH_BREAKPOINT } from "config";

export function useScreenDetector() {
  const [size, setSize] = useState<ScreenSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth < MOBILE_WIDTH_BREAKPOINT
  );

  const handleScreenResize = () => {
    const { innerHeight: height, innerWidth: width } = window;
    setSize({ width, height });
    setIsMobileScreen(width < MOBILE_WIDTH_BREAKPOINT);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedChangeHandler = useCallback(
    debounce(handleScreenResize, 100),
    []
  );

  useEventListener("resize", debouncedChangeHandler);

  return { size, isMobileScreen };
}
